<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ASO80V/tc-custom/9781455602834.jpg?1692834229441" alt="This image is the cover for the book Confederate Ninth Tennessee Infantry"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Confederate Ninth Tennessee Infantry
      </h1>
      <p class="bookDescription body article font2">
        <p>"This volume is a worthy contribution to the regimental history genre. . . . useful for anyone interested in the Ninth or any of the campaigns and battles in which the regiment participated." -William H. Mulligan, Jr., The Civil War News</p><p>"The reader gets a down-to-earth view of the Civil War from ordinary people. . . . recommended to Civil War enthusiasts, especially those interested in primary sources." -www.curledup.com</p><p>Here is the story of the Confederate Ninth Tennessee Infantry, known as the "Southern Confederates," one of the most well-educated, zealously religious, and unbelievably gallant groups of men to engage in the American Civil War. Using the soldiers' actual letters, memoirs, war records, and obituaries, James R. Fleming documents this immortal "band of brothers," which included five of his own ancestors, as they endure the privations of life on the western front. This valuable historical and genealogical resource also includes discussions of the battles at Columbus, Perryville, and Atlanta, as well as the regiment's Order of Battle and each soldier's service record.</p><p>The Confederate Ninth Tennessee Infantry contains a wealth of archival information taken from primary sources. The letters and reminiscences of Capt. James I. Hall, an educator who joined the war to watch over his young students, are published here in full for the first time. The author has also included C. B. Simonton's detailed contemporary account of the unit's organization, as well as transcripts of the speeches given at the presentation and acceptance of the company's first flag. Mr. Fleming also features a regimental chronology and a roster containing approximately eleven hundred official war records from the Compiled Service Records.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        James R. Fleming
      </h2>
      
      <p class="authorDescription body article">James R. Fleming was awarded the Jefferson Davis medal for excellence in preservation and research of Civil War history by the United Daughters of the Confederacy. A graduate of the University of Tennessee at Martin, Mr. Fleming resides in his hometown of Memphis in a restored 1912 foursquare house with his wife, Judge Karen R. Williams. In addition to his writing projects and historical research, he enjoys participating in living histories, working as an interpretive historian for the National Park Service, and collecting Civil War artifacts. Mr. Fleming is also an accomplished bluegrass banjo player and, with his wife, collects and plays period musical instruments.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pelican Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7c992ee6